import type { ViewProps } from "@/types/components";
import { Button, Flex, Stack, Text } from "@mantine/core";
import { IconCactus } from "@tabler/icons-react";

export const View = ({
  title,
  description,
  icon,
  button,
  height = "100%",
  color = "gray.9",
}: ViewProps) => {
  const Icon = icon || IconCactus;
  const ButtonIcon = button?.icon;
  const iconColor = `var(--mantine-color-${color.replace(".", "-")})`;

  return (
    <Flex justify="center" align="center" h={height} mah={600} w="100%">
      <Stack align="center" gap="md">
        <Icon stroke={1.2} size={50} color={iconColor} />
        <Flex direction="column" gap={4} align="center">
          <Text c={color} fz="lg" fw={600} lts={-0.3}>
            {title}
          </Text>
          <Text c={color} fw={500} fz={15} ta="center" maw={400}>
            {description}
          </Text>
        </Flex>
        {button && (
          <Button
            leftSection={
              ButtonIcon ? <ButtonIcon stroke={2.4} size={16} /> : undefined
            }
            onClick={button.onClick}
            mt="md"
            size="md"
            bdrs="xl"
          >
            <Text fz={15} fw={500}>
              {button.label}
            </Text>
          </Button>
        )}
      </Stack>
    </Flex>
  );
};
